import type { RouteRecordRaw } from 'vue-router';

export const main: RouteRecordRaw[] = [
  {
    path: '/analytics/child/:userId',
    name: 'analytics.child',
    component: () => import('./pages/AnalyticsChildPage.vue'),
    meta: { requiresAuth: true, parentOnly: true },
  },
];

export const analytics: RouteRecordRaw[] = [];
